import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleContactDetailDialogTourConfig: AgTechTourConfig = {
    id: 'sale-contact-detail-dialog-tour',
    name: 'Contact Details Tour',
    steps: [
        {
            targetId: 'sale-contact-detail-edit-btn',
            title: 'Edit Contact',
            description: 'Open the full contact record to change their name, address and other details. The tabs below hold the rest of their details.',
            position: 'left',
        },
    ]
}
